// extracted by mini-css-extract-plugin
export default {"rangeInput":"AttendanceCompare_rangeInput__Bbq0w"};